import {
  ControlProps,
  isStringControl,
  RankedTester,
  rankWith,
} from '@jsonforms/core';

import { withJsonFormsControlProps } from '@jsonforms/react';

import React from 'react';
import { MuiInputText } from './mui-controls/MuiInputText';
import { MaterialInputControl } from './controls/MaterialInputControl';

// Concrete implementation
class ConcreteMaterialInputControl extends MaterialInputControl {}

export const textInputControl = (props: ControlProps) => (
  <ConcreteMaterialInputControl {...props} input={MuiInputText} />
);

export const textInputControlTester: RankedTester = rankWith(
  3,
  isStringControl,
);
export default withJsonFormsControlProps(textInputControl);
